import { createRouter, createWebHistory } from "vue-router"

// no auth views
import Home from "../views/Home.vue"
// import AuthLayout from "@/layout/AuthLayout";
import TopLayout from "@/layout/TopLayout"
import Lost from "../views/404.vue"
import Login from "@/views/Login.vue"
import Clients from "@/views/System/Clients/Clients"
import Positions from "@/views/System/Positions/Positions"
import Client from "@/views/System/Clients/Client"
import NewClient from "@/views/System/Clients/NewClient"
import DashboardLayout from "@/layout/DashboardLayout"
import SystemUsers from "@/views/System/SystemUsers"
import NewSystemUser from "@/views/System/NewSystemUser"
import ManageClaims from "@/views/System/ManageClaims"
import Employee from "@/views/System/Employees/Employee"
import NewEmployee from "@/views/System/Employees/NewEmployee"
import Employees from "@/views/System/Employees/Employees"
import Requests from "@/views/Requests/Requests"
import Request from "@/views/Requests/Request"
import RequestCard from "@/views/Requests/RequestDetailsCard"
import Dashboard from "@/views/Dashboard"
import General from "@/views/System/Clients/General"
import ClientUsers from "@/views/System/Clients/Users"
import PositionForm from "@/views/Positions/PositionForm"
import Config from "@/views/System/Settings/SystemConfig.vue"
import ClientRequests from "@/views/System/Clients/Requests"
import ClientConfig from "@/views/System/Clients/ClientConfig.vue"
import EmployeeRequests from "@/views/System/Employees/Requests"
import EmployeeDetailsCard from "@/views/Cards/EmployeeDetailsCard"
// import EmployeePaymentDetailsCard from "@/views/Cards/EmployeePaymentDetailsCard"
// import PaymentCardForm from "@/views/System/Employees/PaymentCardForm"
import EmployeeDocuments from "@/views/System/Employees/EmployeeDocuments"
import EmployeeReviews from "@/views/System/Employees/Reviews.vue"
import RequestForm from "@/views/Requests/RequestForm"
import RequestFormMulti from "@/views/Requests/RequestFormMulti.vue"
import UserForm from "@/views/System/Clients/UserForm"
import Invoices from "@/views/Invoices/Invoices"
import InvoiceForm from "@/views/Invoices/InvoiceForm"
import RequestsSearchTable from "@/views/RequestSearch/RequestsSearchTable"
import MyRequests from "@/views/Employee/MyRequests"
import Profile from "@/views/Profile"
import Services from "@/views/System/Services/Services"
import ServiceForm from "@/views/Services/ServiceForm.vue"
import ClientRegistration from "@/views/Clients/ClientRegistration.vue"
import AboutUs from "@/views/AboutUs.vue"
import EmployeeRegistration from "@/views/Employee/EmployeeRegistration.vue"
import RequestFormPage from "@/views/Requests/RequestFormPage.vue"
import Register from "@/views/Register.vue"
import LandingPage from "@/canvasTemplate/landingPage.vue"

const routes = [
  {
    path: "/admin",
    redirect: "/dashboard",
    meta: { requiresAuth: true },
    component: DashboardLayout,
    children: [
      {
        path: "/dashboard",
        name: "Dashboard",
        meta: { role: ["system"] },
        components: { default: Dashboard },
      },
      {
        path: "/systemUsers",
        name: "System users",
        meta: { role: ["system"] },
        components: { default: SystemUsers },
      },
      {
        path: "/systemUsers/new",
        name: "new System users",
        meta: { role: ["system"] },
        components: { default: NewSystemUser },
      },
      {
        path: "/systemUser/:id",
        name: "System user",
        meta: { role: ["system"] },
        components: { default: NewSystemUser },
        props: true
      },
      {
        path: "/requests",
        name: "Requests",
        meta: { role: ["system", "client"] },
        components: { default: Requests },
      },
      {
        path: "/requests/new",
        name: "newRequest",
        meta: { role: ["system", "client"] },
        components: { default: RequestFormPage },
        props: true
      },
      // {
      //   path: "/requests/multiCreate",
      //   name: "newMultiRequest",
      //   meta: { role: ["system", "client"] },
      //   components: { default: RequestFormMulti },
      //   props: true
      // },
      {
        path: "/requests/:id",
        name: "Request",
        // redirect: to => {
        //   // the function receives the target route as the argument
        //   // we return a redirect path/location here.
        //   return { path: "requests/"+to.params.id+"/info"}
        // },
        meta: { role: ["system", "employee", "client"] },
        components: { default: Request },
        // children: [
        //     {
        //       path: "info",
        //       name: "requestInfo",
        //       meta: { role: ["system"] },
        //       components: { default: RequestCard },
        //       props: true
        //   }
        //   ]
      },
      {
        path: "/invoices",
        name: "Invoices",
        meta: { role: ["system", "employee"] },
        children: [
          {
            path: "",
            name: "invoiceList",
            meta: { role: ["system", "employee"] },
            components: { default: Invoices },
            children: [
            ]
          },
          // {
          //   path: "new",
          //   name: "newInvoice",
          //   meta: { role: ["system"] },
          //   components: { default: InvoiceForm },
          //   props: true
          // },
          // {
          //   path: ":id",
          //   name: "invoiceRecord",
          //   meta: { role: ["system"] },
          //   components: { default: PositionForm },
          // },
          // {
          //   path: ":id/edit",
          //   name: "editInvoiceRecord",
          //   meta: { role: ["system"] },
          //   components: { default: PositionForm },
          // },
        ]
      },

      {
        path: "/shift-plans",
        name: "shiftPlans",
        meta: { role: ["system"] },
        children: [
          {
            path: "",
            name: "shiftPlansList",
            meta: { role: ["system"] },
            components: { default: Services },
            children: [
              {
                path: "new",
                name: "newShiftPlan",
                meta: { role: ["system"] },
                components: { default: ServiceForm },
                props: true
              },
              {
                path: ":id",
                name: "shiftPlanRecord",
                meta: { role: ["system"] },
                components: { default: ServiceForm },
              },
              {
                path: ":id/edit",
                name: "editShiftPlanRecord",
                meta: { role: ["system"] },
                components: { default: ServiceForm },
              },
            ]
          },
        ]
      },
      {
        path: "/services",
        name: "Services",
        meta: { role: ["system"] },
        children: [
          {
            path: "",
            name: "serviceList",
            meta: { role: ["system"] },
            components: { default: Services },
            children: [
              {
                path: "new",
                name: "newService",
                meta: { role: ["system"] },
                components: { default: ServiceForm },
                props: true
              },
              {
                path: ":id",
                name: "serviceRecord",
                meta: { role: ["system"] },
                components: { default: ServiceForm },
              },
              {
                path: ":id/edit",
                name: "editServiceRecord",
                meta: { role: ["system"] },
                components: { default: ServiceForm },
              },
            ]
          },
        ]
      },
      {
        path: "/clients",
        meta: { role: ["system"] },
        children: [
          {
            path: "",
            name: "clientList",
            meta: { role: ["system"] },
            components: { default: Clients },
          },
          {
            path: "new",
            name: "newClient",
            meta: { role: ["system"] },
            components: { default: NewClient },
          },
          {
            path: ":id",
            name: "ClientRecord",
            meta: { role: ["system"] },
            components: { default: Client },
            redirect: to => {
              // the function receives the target route as the argument
              // we return a redirect path/location here.
              return { path: "/clients/"+to.params.id+"/info"}
            },
            props: true,
            children: [
              {
                path: "info",
                name: "clientGeneral",
                meta: { role: ["system"] },
                components: { default: General },
                props: true
              },
              // {
              //   path: "users",
              //   name: "clientUsers",
              //   meta: { role: ["system"] },
              //   components: { default: ClientUsers },
              //   props: true,
              //   children: [
              //     {
              //       path: "new",
              //       name: "newClientUser",
              //       meta: { role: ["system"] },
              //       components: { default: UserForm },
              //       props: true
              //     },
              //       {
              //         path: ":userId/edit",
              //         name: "editClientUser",
              //         meta: { role: ["system"] },
              //         components: { default: UserForm },
              //         props: true
              //       }
              //     ]
              // },
              {
                path: "requests",
                name: "clientRequests",
                meta: { role: ["system"] },
                components: { default: ClientRequests },
                props: true
              },
              {
                path: "config",
                name: "clientConfig",
                meta: { role: ["system"] },
                components: { default: ClientConfig },
                props: true
              },
            ]
          },
          {
            path: ":id/edit",
            name: "editClient",
            meta: { role: ["system"] },
            components: { default: NewClient },
          },
        ]
      },
      {
        path: "/configuration",
        name: "config",
        meta: { role: ["system"] },
        components: { default: Config },
      },
      {
        path: "/employees",
        name: "Employee",
        meta: { role: ["system"] },
        children: [
          {
            path: "",
            name: "employeesList",
            meta: { role: ["system"] },
            components: { default: Employees },
          },
          {
            path: "new",
            name: "newEmployee",
            meta: { role: ["system"] },
            components: { default: NewEmployee },
          },
          {
            path: ":id",
            name: "EmployeeRecord",
            meta: { role: ["system"] },
            redirect: to => {
              // the function receives the target route as the argument
              // we return a redirect path/location here.
              return { path: "/employees/"+to.params.id+"/info"}
            },
            components: { default: Employee },
            children: [
                {
                  path: "info",
                  name: "employeeGeneral",
                  meta: { role: ["system"] },
                  components: { default: EmployeeDetailsCard },
                  props: true
                },
              {
                path: "documents",
                name: "employeeDocuments",
                meta: { role: ["system"] },
                components: { default: EmployeeDocuments },
                props: true,
                // children: [
                //   {
                //     path: "upload",
                //     name: "uploadDocs",
                //     meta: { role: ["system"] },
                //     components: { default: PaymentCardForm },
                //     props: true,
                //   },
                // ]
              },
              {
                path: "requests",
                name: "employeeRequests",
                meta: { role: ["system"] },
                components: { default: EmployeeRequests },
                props: true
              },
              {
                path: "reviews",
                name: "employeeReviews",
                meta: { role: ["system"] },
                components: { default: EmployeeReviews },
                props: true
              },
                // {
                //   path: "paymentDetails",
                //   name: "employeePaymentDetails",
                //   meta: { role: ["system"] },
                //   components: { default: EmployeePaymentDetailsCard },
                //   props: true,
                //   children: [
                //     {
                //       path: "edit",
                //       name: "editPaymentCard",
                //       meta: { role: ["system"] },
                //       components: { default: PaymentCardForm },
                //       props: true,
                //     },
                //   ]
                // },
              // {
              //   path: "invoices",
              //   name: "employeeInvoices",
              //   meta: { role: ["system"] },
              //   components: { default: EmployeeRequests },
              //   props: true
              // }
              ]
          },
          {
            path: ":id/edit",
            name: "editEmployee",
            meta: { role: ["system"] },
            components: { default: NewEmployee },
          },
        ]
      },
      {
        path: "/manage-claims",
        name: "manage-claims",
        meta: { role: ["system"] },
        components: { default: ManageClaims },
      },

      {
        path: "/profile/edit",
        name: "editEmployeeProfile",
        meta: { role: ["employee"] },
        components: { default: NewEmployee },
      },
      {
        path: "/account",
        name: "clientAccount",
        meta: { role: ["client"] },
        components: { default: Client },
        redirect: to => {
          // the function receives the target route as the argument
          // we return a redirect path/location here.
          return { path: "/account/info"}
        },
        props: true,
        children: [
          {
            path: "info",
            name: "accountGeneral",
            meta: { role: ["client"] },
            components: { default: General },
            props: true
          },
          {
            path: "users",
            name: "clientAccountUsers",
            meta: { role: ["client"] },
            components: { default: ClientUsers },
            props: true,
            children: [
              {
                path: ":id/edit",
                name: "editClientAccountUser",
                meta: { role: ["client"] },
                components: { default: UserForm },
                props: true
              }
            ]
          }
          ]
      },
      {
        path: "/account/edit",
        name: "editClientAccount",
        meta: { role: ["client"] },
        components: { default: NewClient },
      },
      {
        path: "/profile",
        name: "userProfile",
        meta: { role: ["employee"] },
        redirect: to => {
          // the function receives the target route as the argument
          // we return a redirect path/location here.
          return { path: "/profile/info"}
        },
        components: { default: Profile },
        children: [
          {
            path: "info",
            name: "employeeProfile",
            meta: { role: ["employee"] },
            components: { default: EmployeeDetailsCard },
          },
          {
            path: "documents",
            name: "employeeProfileDocuments",
            meta: { role: ["employee"] },
            components: { default: EmployeeDocuments },
            // children: [
            //   {
            //     path: "upload",
            //     name: "uploadDocs",
            //     meta: { role: ["system"] },
            //     components: { default: PaymentCardForm },
            //     props: true,
            //   },
            // ]
          },
        ]
      },
      {
        path: "/find-a-shift",
        name: "findAShift",
        meta: { role: "employee" },
        components: { default: RequestsSearchTable },
        props: true
      },
      {
        path: "/my-requests",
        name: "myRequests",
        meta: { role: "employee" },
        components: { default: MyRequests },
        props: true
      },
      // {
      //   path: "/requests/:id",
      //   name: "Request",
      //   meta: {role: ["employee"]},
      //   components: {default: NormalUserRequestView}
      // }
      // {
      //   path: "/invoices",
      //   name: "Invoices",
      //   meta: { role: "OWNER" },
      //   components: { default: Invoices },
      // },
      // {
      //   path: "/invoices/new",
      //   name: "new invoice",
      //   components: { default: NewInvoice },
      // },
    ],
  },
  {
    path: "/",
    component: TopLayout,
    children: [
      {
        path: "/",
        name: "home",
        components: { default: Home },
        meta: {
          seo: {
            title: "Heed | Home Healthcare Services in Cyprus",
            description: "Book licensed nurses, physiotherapists, and doctors for personalised care at home in Cyprus.",
            canonical: "https://heed.com.cy/",
          },
        },
      },
      {
        path: "/login",
        name: "login",
        components: { default: Login },
        props: true
      },
      {
        path: "/about-us",
        name: "AboutUs",
        components: { default: AboutUs },
        props: true,
        meta: {
          seo: {
            title: "About Heed | Home Healthcare in Cyprus",
            description: "Learn about Heed and how we connect people in Cyprus with trusted healthcare professionals for home care.",
            canonical: "https://heed.com.cy/about-us",
          },
        },
      },
      {
        path: "/register",
        name: "register",
        components: { default: Register },
        props: true,
        meta: {
          seo: {
            title: "Register | Heed",
            description: "Create a Heed account to book home healthcare services in Cyprus.",
            canonical: "https://heed.com.cy/register",
          },
        },
      },
      {
        path: "/register-healthcare-professional",
        name: "register-healthcare-professional",
        components: { default: EmployeeRegistration },
        props: true,
        meta: {
          seo: {
            title: "Register as a Healthcare Professional | Heed",
            description: "Join Heed as a nurse, physiotherapist, doctor, or healthcare professional in Cyprus.",
            canonical: "https://heed.com.cy/register-healthcare-professional",
          },
        },
      },
      {
        path: "/register-client",
        name: "register-client",
        components: { default: ClientRegistration },
        props: true,
        meta: {
          seo: {
            title: "Register as a Client | Heed",
            description: "Register with Heed to request professional home healthcare services in Cyprus.",
            canonical: "https://heed.com.cy/register-client",
          },
        },
      },
      {
        path: "/join-us",
        name: "JoinUs",
        components: { default: EmployeeRegistration },
        props: true,
        meta: {
          seo: {
            title: "Join Heed | Healthcare Professional Jobs in Cyprus",
            description: "Apply to provide home healthcare services through Heed in Cyprus.",
            canonical: "https://heed.com.cy/join-us",
          },
        },
      },
      {
        path: "/:pathMatch(.*)*",
        name: "lost",
        components: { default: Lost },
      },
      {
        path: "/error",
        name: "error",
        components: { default: Lost },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  routes,
})

export default router
